import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mb-8"
}
const _hoisted_2 = {
  key: 0,
  class: "col-md-6 col-12 mb-5"
}
const _hoisted_3 = { class: "h-100 d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "fw-bold mb-5" }
const _hoisted_5 = { class: "mb-8" }
const _hoisted_6 = {
  target: "_blank",
  href: "https://cvec.etudiant.gouv.fr"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "d-flex flex-column align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-circle-check mb-5",
  style: {"font-size":"3rem","color":"var(--kt-success)"}
}, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 1,
  class: "col-md-6 col-12 mb-5"
}
const _hoisted_12 = { class: "h-100 d-flex flex-column justify-content-between" }
const _hoisted_13 = { class: "fw-bold mb-5" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "d-flex flex-column align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-circle-check mb-5",
  style: {"font-size":"3rem","color":"var(--kt-success)"}
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "spinner-border spinner-border-sm"
}, null, -1)
const _hoisted_20 = { class: "btn-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cvec = _resolveComponent("Cvec")!
  const _component_BasicCard = _resolveComponent("BasicCard")!
  const _component_FileInput = _resolveComponent("FileInput")!

  return (_ctx.infos?.documents && Object.keys(_ctx.infos?.documents).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.infos?.documents?.cvec)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_BasicCard, {
                "no-inline-border": "",
                "explicit-containment": "",
                class: "mb-5 h-100"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('views.portal.cases.uploadArea.cvec.title')), 1),
                    _createElementVNode("p", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.$t('views.portal.cases.uploadArea.cvec.description')) + " ", 1),
                      _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('global.texts.learnMore')), 1)
                    ]),
                    (_ctx.infos.documents.cvec?.isValid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.portal.cases.uploadArea.cvec.status.uploaded')), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.portal.cases.uploadArea.cvec.status.numCvec')) + " " + _toDisplayString(_ctx.infos.documents.cvec?.numCvec), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.portal.cases.uploadArea.cvec.status.notUploaded')), 1),
                          _createVNode(_component_Cvec, {
                            name: "cvec",
                            required: ""
                          })
                        ]))
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.infos?.documents?.attestationBac)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_BasicCard, {
                "no-inline-border": "",
                "explicit-containment": "",
                class: "mb-5 h-100"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$t('views.portal.cases.uploadArea.attestationBac.title')) + _toDisplayString(_ctx.admissibleInfos.formationEtape - 1) + " " + _toDisplayString(_ctx.admissibleInfos.school === 'ESILV' ? _ctx.$t('views.portal.cases.uploadArea.attestationBac.orMore') : null), 1),
                    (_ctx.infos?.documents?.attestationBac?.isValid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.portal.cases.uploadArea.attestationBac.status.uploaded', {etape: _ctx.admissibleInfos.formationEtape - 1})), 1),
                            _hoisted_17
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.portal.cases.uploadArea.attestationBac.status.notUploaded')) + _toDisplayString(_ctx.admissibleInfos.formationEtape - 1) + " " + _toDisplayString(_ctx.admissibleInfos.school === 'ESILV' ? _ctx.$t('views.portal.cases.uploadArea.attestationBac.orMore') : null), 1),
                          _createVNode(_component_FileInput, {
                            onOnUpload: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFileUpload('attestationBac', $event))),
                            name: "attestationBac",
                            errors: _ctx.uploadErrors.attestationBac,
                            accept: "image/png, image/jpeg, application/pdf",
                            errorFileType: _ctx.uploadFileType.attestationBac
                          }, null, 8, ["errors", "errorFileType"]),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["btn btn-primary btn-violet animated-submit mt-5", { disabled: _ctx.isSubmitting }]),
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitFiles && _ctx.submitFiles(...args)))
                          }, [
                            _hoisted_19,
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('global.buttons.send')), 1)
                          ], 2)
                        ]))
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}